import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import NewsList from "@/pages/NewsList";
import NewsDetail from "@/pages/NewsDetail";
import EventsPage from "@/pages/EventsPage";
import GalleryPage from "@/pages/GalleryPage";
import RegisterPage from "@/pages/RegisterPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" theme="dark" richColors />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/berita" element={<NewsList />} />
            <Route path="/berita/:id" element={<NewsDetail />} />
            <Route path="/event" element={<EventsPage />} />
            <Route path="/galeri" element={<GalleryPage />} />
            <Route path="/gabung" element={<RegisterPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
